import React, { useMemo } from "react";

export default function TopTenSetupSection({
    topCategory,
    setTopCategory,
    topProductCategories,
    categoryDefects,
    topCodes,
    onToggle,
    onSave,
}) {
    const sewingDefects = useMemo(
        () =>
            categoryDefects.filter((item) => {
                const category = [
                    item.product_category,
                    item.product_category_eng,
                    item.product_category_thai,
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase();

                return category.includes("sewing defect");
            }),
        [categoryDefects],
    );

    return (
        <section className="setup-panel top-ten-panel">
            <header className="top-ten-head">
                <div>
                    <span>Defect ranking</span>
                    <h2>Top 10 Sewing Defect</h2>
                </div>
                <strong>{topCodes.length}/10</strong>
            </header>
            <label className="top-ten-category-select">
                Product category
                <select value={topCategory} onChange={(e) => setTopCategory(e.target.value)}>
                    {topProductCategories.map((item) => <option value={item} key={item}>{item}</option>)}
                </select>
            </label>
            <p className="setup-hint mt-2">Selected defects are marked by their display order. Click again to remove.</p>
            {topCodes.length > 0 && (
                <div className="top-ten-selected-summary">
                    {topCodes.map((code, index) => {
                        const defect = sewingDefects.find((item) => item.defect_code === code);
                        return <span key={code}>{index + 1}. {defect ? `${code} - ${defect.defect_desc_thai}` : code}</span>;
                    })}
                </div>
            )}
            <div className="top-ten-list">
                {sewingDefects.map((item) => {
                    const position = topCodes.indexOf(item.defect_code);
                    const selected = position !== -1;
                    return (
                        <button key={item.defect_code} className={selected ? "selected" : ""} onClick={() => onToggle(item.defect_code)}>
                            <span>{selected ? position + 1 : "+"}</span>
                            <b>{item.defect_code}</b>
                            <small>{item.defect_desc_thai}</small>
                        </button>
                    );
                })}
            </div>
            {!sewingDefects.length && <div className="setup-empty">No Sewing Defect records found.</div>}
            <button className="setup-primary" onClick={onSave}>Save Top 10 ({topCodes.length}/10)</button>
        </section>
    );
}